/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeBotAuditLogPageResponse,
  ApiEnvelopeBotDisconnectPageResponse,
  BotAuditLogExportDisconnectsParams,
  BotAuditLogGetAuditLogParams,
  BotAuditLogGetDisconnectsParams
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type botAuditLogGetAuditLogResponse200 = {
  data: ApiEnvelopeBotAuditLogPageResponse
  status: 200
}

export type botAuditLogGetAuditLogResponse400 = {
  data: ApiEnvelopeBotAuditLogPageResponse
  status: 400
}

export type botAuditLogGetAuditLogResponse401 = {
  data: ApiEnvelopeBotAuditLogPageResponse
  status: 401
}

export type botAuditLogGetAuditLogResponse403 = {
  data: ApiEnvelopeBotAuditLogPageResponse
  status: 403
}

export type botAuditLogGetAuditLogResponse404 = {
  data: ApiEnvelopeBotAuditLogPageResponse
  status: 404
}

export type botAuditLogGetAuditLogResponseSuccess = (botAuditLogGetAuditLogResponse200) & {
  headers: Headers;
};
export type botAuditLogGetAuditLogResponseError = (botAuditLogGetAuditLogResponse400 | botAuditLogGetAuditLogResponse401 | botAuditLogGetAuditLogResponse403 | botAuditLogGetAuditLogResponse404) & {
  headers: Headers;
};

export type botAuditLogGetAuditLogResponse = (botAuditLogGetAuditLogResponseSuccess | botAuditLogGetAuditLogResponseError)

export const getBotAuditLogGetAuditLogUrl = (botId: string,
    params?: BotAuditLogGetAuditLogParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/botengine/${botId}/auditlog?${stringifiedParams}` : `/api/botengine/${botId}/auditlog`
}

export const useBotAuditLogGetAuditLogHook = (): (botId: string,
    params?: BotAuditLogGetAuditLogParams, options?: RequestInit) => Promise<botAuditLogGetAuditLogResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    params?: BotAuditLogGetAuditLogParams, options?: RequestInit) => {

        return customFetcher(getBotAuditLogGetAuditLogUrl(botId,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botAuditLogGetDisconnectsResponse200 = {
  data: ApiEnvelopeBotDisconnectPageResponse
  status: 200
}

export type botAuditLogGetDisconnectsResponse401 = {
  data: ApiEnvelopeBotDisconnectPageResponse
  status: 401
}

export type botAuditLogGetDisconnectsResponse403 = {
  data: ApiEnvelopeBotDisconnectPageResponse
  status: 403
}

export type botAuditLogGetDisconnectsResponseSuccess = (botAuditLogGetDisconnectsResponse200) & {
  headers: Headers;
};
export type botAuditLogGetDisconnectsResponseError = (botAuditLogGetDisconnectsResponse401 | botAuditLogGetDisconnectsResponse403) & {
  headers: Headers;
};

export type botAuditLogGetDisconnectsResponse = (botAuditLogGetDisconnectsResponseSuccess | botAuditLogGetDisconnectsResponseError)

export const getBotAuditLogGetDisconnectsUrl = (params?: BotAuditLogGetDisconnectsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/botengine/disconnects?${stringifiedParams}` : `/api/botengine/disconnects`
}

export const useBotAuditLogGetDisconnectsHook = (): (params?: BotAuditLogGetDisconnectsParams, options?: RequestInit) => Promise<botAuditLogGetDisconnectsResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: BotAuditLogGetDisconnectsParams, options?: RequestInit) => {

        return customFetcher(getBotAuditLogGetDisconnectsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botAuditLogExportDisconnectsResponse200 = {
  data: void
  status: 200
}

export type botAuditLogExportDisconnectsResponseSuccess = (botAuditLogExportDisconnectsResponse200) & {
  headers: Headers;
};
;

export type botAuditLogExportDisconnectsResponse = (botAuditLogExportDisconnectsResponseSuccess)

export const getBotAuditLogExportDisconnectsUrl = (params?: BotAuditLogExportDisconnectsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/botengine/disconnects/export?${stringifiedParams}` : `/api/botengine/disconnects/export`
}

export const useBotAuditLogExportDisconnectsHook = (): (params?: BotAuditLogExportDisconnectsParams, options?: RequestInit) => Promise<botAuditLogExportDisconnectsResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: BotAuditLogExportDisconnectsParams, options?: RequestInit) => {

        return customFetcher(getBotAuditLogExportDisconnectsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


